import {
  Action,
  configureStore,
  ConfigureStoreOptions,
  ThunkAction,
} from "@reduxjs/toolkit";

import caseSlice from "./case/slice";
import cbctSlice from "./cbct/slice";
import modalSlice from "./modal/slice";
import { panoramicApi } from "./panoramic/api";
import paymentSlice from "./payment/slice";
import trgSlice from "./trg/slice";
import userSlice from "./user/slice";
import { api } from "./api";
import { rtkQueryErrorLogger } from "./error-logger";

const serializableCheckIgnoredActions = [
  `${api.reducerPath}/executeQuery/fulfilled`,
  `${api.reducerPath}/executeMutation/fulfilled`,
  `${api.reducerPath}/queryResultPatched`,
  `${api.reducerPath}/updateQueryResult`,
  `${api.reducerPath}/patchQueryResult`,
  `${panoramicApi.reducerPath}/executeQuery/fulfilled`,
  `${panoramicApi.reducerPath}/executeMutation/fulfilled`,
  `${panoramicApi.reducerPath}/queryResultPatched`,
  `${panoramicApi.reducerPath}/updateQueryResult`,
  `${panoramicApi.reducerPath}/patchQueryResult`,
];

const serializableCheckIgnoredPaths = [
  `${api.reducerPath}.queries`,
  `${api.reducerPath}.mutations`,
  `${panoramicApi.reducerPath}.queries`,
  `${panoramicApi.reducerPath}.mutations`,
];

export const createStore = (
  options?: ConfigureStoreOptions["preloadedState"] | undefined
) =>
  configureStore({
    reducer: {
      caseSlice,
      userSlice,
      modalSlice,
      trgSlice,
      cbctSlice,
      paymentSlice,
      [api.reducerPath]: api.reducer,
      [panoramicApi.reducerPath]: panoramicApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: serializableCheckIgnoredActions,
          ignoredPaths: serializableCheckIgnoredPaths,
        },
      })
        .concat(rtkQueryErrorLogger)
        .concat(api.middleware)
        .concat(panoramicApi.middleware),
    ...options,
  });

export const store = createStore({
  devTools: process.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
